<template>
  <div class="yhc-ef-datetime-inputs--inner-item--pickup-date-info">
    <div class="yhc-ef-datetime-inputs--inner-item--pickup-date-info--label">
      お届け日
    </div>
    <div class="yhc-ef-datetime-inputs--inner-item--pickup-date-info--dates">
      {{ displayDeliveryDate }}
    </div>
    <div
      v-if="isRemoteIsland && canCalcDate && !isSameDayDelivery"
      class="yhc-ef-datetime-inputs--inner-item--pickup-date-info--desc"
    >
      <div class="text-danger">※上記日付までにお届けします</div>
      <div class="text-danger">※詳細は担当店より連絡します</div>
    </div>
    <div
      v-else-if="canCalcDate && !isSameDayDelivery"
      class="yhc-ef-datetime-inputs--inner-item--pickup-date-info--desc"
    >
      <div>
        {{ $yhcefs.$userInputData.pref_from_name }}発
        {{ $yhcefs.$userInputData.pref_to_name }}着なら 15時までのお預かりで 最短{{
          $yhcefs.$userInputData.deliverNeedDays
        }}日でお届け
      </div>
      <!-- <div>※離島へのお届けは、通常よりもお時間をいただく場合がございます。</div> -->
    </div>
    <div
      v-if="deliveryWorkingDaysChangeNote"
      class="delivery-date-warning"
    >
      {{ deliveryWorkingDaysChangeNote }}
    </div>
  </div>
</template>
<script lang="ts">
import { YhcEstimateFormFrontService } from '../../YhcEstimateFormFrontService'

export default {
  name: 'YhcEfDatetimeMinDeliverDate',
  inject: ['YhcEstimateFormFrontServiceInstance'],
  computed: {
    $yhcefs(): YhcEstimateFormFrontService {
      return this.YhcEstimateFormFrontServiceInstance
    },
    canCalcDate(): boolean {
      return (
        this.$yhcefs.$userInputData.deliveryDateDisplayLabel.indexOf('年') >= 0 &&
        !this.$yhcefs.$userInputData.pickupDateResetFlag &&
        !!this.$yhcefs.$userInputData.pickupSelectedDate
      )
    },
    isSameDayDelivery(): boolean {
      return this.$yhcefs.$userInputData.isSameDayPickupAndDelivery
    },
    isRemoteIsland(): boolean {
      return (
        this.$yhcefs.$userInputData.zip_from_yhc_master?.isRemoteIsland === true ||
        this.$yhcefs.$userInputData.zip_to_yhc_master?.isRemoteIsland === true
      )
    },
    deliveryWorkingDaysChangeNote(): string | null {
      const uid = this.$yhcefs.$userInputData
      void this.$yhcefs.masterVersionPeriods
      void uid.toWorkingDayPatternByVersionId
      void uid.regularWorkingDayRecords
      void uid.zip_to
      void this.$yhcefs.isFleaMarket
      void this.$yhcefs.baseDatetime
      return uid.deliveryWorkingDaysChangeNote
    },
    displayDeliveryDate(): string {
      if (this.isRemoteIsland && this.canCalcDate) {
        const adjusted = this.$yhcefs.$userInputData.remoteIslandDeliveryDateAdjusted
        if (adjusted) {
          return $core.$dayjs(adjusted).format('YYYY年MM月DD日')
        }
        const pickupDate = this.$yhcefs.$userInputData.pickupSelectedDate
        if (pickupDate) {
          return $core.$dayjs(pickupDate).add(14, 'day').format('YYYY年MM月DD日')
        }
        return ''
      }

      const adjustedDate =
        this.$yhcefs.$userInputData.deliveryDateAdjustedForFixedHolidays
      if (adjustedDate) {
        return $core.$dayjs(adjustedDate).format('YYYY年MM月DD日')
      }

      return this.$yhcefs.$userInputData.deliveryDateDisplayLabel
    },
  },
}
</script>
<style>
.delivery-date-warning {
  color: red;
  font-size: 13px;
  margin-top: 5px;
  width: 100%;
}
</style>
